import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import Table from 'jsx/elements/tables/Table';
import {apiCall} from '../../components/special/apiCall';
import TextDate from 'components/text/TextDate';
import TextAmount from 'components/text/TextAmount';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const DeRegisteredDefaultDebtorRecords = (props)  => {
  const [data, setData] = useState([]);

  useEffect(() => {
    
    apiCall(BASE_URL + '/Addon/ddupload/overview/deregisteredclaims').then(res => {
      console.log("deregisteredclaims", res);
      setData(res);
    });

  }, []);


  return (
    <div>
      {data.length > 0 && (
        <div>
          <ReactTooltip/>
          <Table
          cols={['90px', '170px', '200px', '200px', '']}
          head={[
            'Auðkenni',
            'Kennitölur',
            'Kröfunúmer',
            'Upplýsingar',
            'Dagsetningar'                    
          ]}
          hover="true"
        >
          {data.map((item, index) => 
            <tr key={index}>
              <td>
                {item.claimID}               
              </td>
              <td>                
                <table>
                    <tbody>
                    <tr>
                        <th>Skuldari</th>
                        <td>{item.debtorRegno}</td>
                    </tr>
                    <tr>
                        <th>Kröfuhafi</th>
                        <td>{item.claimOwnerRegno}</td>
                    </tr>
                    <tr>
                        <th>Embætti</th>
                        <td>{item.publicOfficeRegno}</td>
                    </tr>
                    </tbody>
                </table>

              </td>                                
              <td>
                {item.claimNumber}
              </td>                                      
              <td>
                <table>
                    <tbody>
                    <tr>
                        <th>Tegund</th>
                        <td>{item.claimType}</td>
                    </tr>
                    <tr>
                        <th>Staða</th>
                        <td>{item.statusID}</td>
                    </tr>
                    <tr>
                        <th>Upphæð</th>
                        <td><TextAmount value={item.capital}/> {item.currency}</td>
                    </tr>
                    </tbody>
                </table>               
              </td>                            
              <td>
                <table>
                    <tbody>
                    <tr>
                    <th>Kröfudags.</th>
                    <td><TextDate value={item.claimDate}/></td>
                    </tr>
                    <tr>
                    <th>Færsla skráð</th>
                    <td><TextDate value={item.registerDate}/></td>
                    </tr>                      
                    <tr>
                    <th>Varð virk</th>
                    <td><TextDate value={item.activateDate}/></td>
                    </tr>
                    <tr>
                    <th>Afskráð</th>
                    <td><TextDate value={item.deactivateDate}/></td>
                    </tr>
                    <tr>
                    <th>Ástæða afskrán.</th>
                    <td>{item.deactivateReason}</td>
                    </tr>
                    </tbody>
                </table>
              </td>
            </tr>
          )} 
        </Table>
        </div>
      )}
  </div>
  );
};
